(function () {
  'use strict';

  var CONFIG = {
    giftVariantId: 51535107227927,
    giftPropertyKey: '_gencon_free_spindown',
    giftPropertyValue: 'Gen Con Sale 2026',
    promotionEndsAtUtc: Date.parse('2026-09-02T04:59:59Z'),
    spindownCollectionHandle: 'gen-con-free-spindown-eligible',
    polyCollectionHandle: 'polyhedral-dice-sets',
    rewardRule: 'gencon-2026-v2-collection-backed',
    debounceMs: 120
  };

  var collectionPromises = {};
  var reconcilePromise = null;
  var pending = false;
  var timer = null;
  var checkoutPromise = null;
  var checkoutPreparing = false;
  var checkoutBypassForm = null;

  function endpoint(name, fallback) {
    return window.theme && window.theme.routes && window.theme.routes[name]
      ? window.theme.routes[name]
      : fallback;
  }

  function requestHeaders() {
    return {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json'
    };
  }

  function isPromotionActive() {
    return Date.now() <= CONFIG.promotionEndsAtUtc;
  }

  function schedulePromotionExpiryRefresh() {
    var remaining = CONFIG.promotionEndsAtUtc - Date.now();
    if (remaining <= 0 || !document.querySelector('[data-ib-cart-root], #CartDrawer')) return;
    var delay = Math.min(remaining + 1500, 2147483000);
    window.setTimeout(function () {
      if (!isPromotionActive()) {
        window.location.reload();
      } else {
        schedulePromotionExpiryRefresh();
      }
    }, delay);
  }

  function loadCollectionProductIds(handle) {
    if (collectionPromises[handle]) return collectionPromises[handle];

    var url = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250';
    collectionPromises[handle] = fetch(url, {
      credentials: 'same-origin',
      method: 'GET',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not load promotion eligibility.');
      return response.json();
    }).then(function (data) {
      var ids = {};
      (data.products || []).forEach(function (product) {
        ids[String(product.id)] = true;
      });
      return ids;
    }).catch(function (error) {
      delete collectionPromises[handle];
      throw error;
    });

    return collectionPromises[handle];
  }

  function isManagedGiftLine(item) {
    return Number(item && item.variant_id) === CONFIG.giftVariantId
      && item.properties
      && item.properties[CONFIG.giftPropertyKey] === CONFIG.giftPropertyValue;
  }

  function eligibleQuantity(cart, productIds) {
    return (cart.items || []).reduce(function (total, item) {
      if (isManagedGiftLine(item)) return total;
      return productIds[String(item && item.product_id)] === true
        ? total + Number(item.quantity || 0)
        : total;
    }, 0);
  }

  function getCart() {
    return fetch(endpoint('cart', '/cart.js') + '?t=' + Date.now(), {
      credentials: 'same-origin',
      method: 'GET',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not read the cart.');
      return response.json();
    });
  }

  function updateCartAttributes(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: requestHeaders(),
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not save the reward packing record.');
      return response.json();
    });
  }

  function cartSignature(cart) {
    return (cart.items || []).map(function (item) {
      return [String(item.key || item.variant_id || ''), Number(item.quantity || 0)].join(':');
    }).sort().join('|') + '::' + String(Number(cart.total_price || 0));
  }

  function managedGiftQuantity(cart) {
    return (cart.items || []).reduce(function (total, item) {
      return isManagedGiftLine(item) ? total + Number(item.quantity || 0) : total;
    }, 0);
  }

  function attributesMatch(cart, expected) {
    var current = cart.attributes || {};
    return Object.keys(expected).every(function (key) {
      return String(current[key] || '') === String(expected[key]);
    });
  }

  function setCheckoutPreparing(value) {
    checkoutPreparing = value;
    window.clearTimeout(timer);
    if (value) {
      document.documentElement.setAttribute('data-ib-checkout-preparing', 'true');
    } else {
      document.documentElement.removeAttribute('data-ib-checkout-preparing');
      if (pending) scheduleReconcile();
    }
  }

  function isCartMutationControl(target) {
    if (!target || !target.closest) return false;
    if (target.closest('[data-ib-checkout], button[name="checkout"]')) return false;
    var form = target.closest('form');
    if (form) {
      var action = String(form.getAttribute('action') || '');
      if (action.indexOf('/cart') !== -1) return true;
    }
    var link = target.closest('a[href*="/cart/change"], a[href*="/cart/add"]');
    return Boolean(link);
  }

  function addGift(quantity) {
    return fetch(endpoint('cartAdd', '/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: requestHeaders(),
      body: JSON.stringify({
        items: [{
          id: CONFIG.giftVariantId,
          quantity: quantity,
          properties: (function () {
            var properties = {};
            properties[CONFIG.giftPropertyKey] = CONFIG.giftPropertyValue;
            return properties;
          }())
        }]
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || data.message || 'Could not add the free Spindown.');
        });
      }
      return response.json();
    });
  }

  function changeGiftLine(key, quantity) {
    return fetch(endpoint('cartChange', '/cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: requestHeaders(),
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || data.message || 'Could not update the free Spindown.');
        });
      }
      return response.json();
    });
  }

  function refreshCartMarkup() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function reconcileGift() {
    if (reconcilePromise) {
      pending = true;
      return reconcilePromise;
    }

    reconcilePromise = (async function () {
      do {
        pending = false;
        var cart = await getCart();
        var qualifyingProductIds = Number(cart.item_count || 0) > 0 && isPromotionActive()
          ? await loadCollectionProductIds(CONFIG.spindownCollectionHandle)
          : {};
        var giftLines = (cart.items || []).filter(isManagedGiftLine);
        var desiredQuantity = isPromotionActive()
          ? eligibleQuantity(cart, qualifyingProductIds)
          : 0;
        var existingQuantity = giftLines.reduce(function (total, item) {
          return total + Number(item.quantity || 0);
        }, 0);
        var needsChange = existingQuantity !== desiredQuantity || giftLines.length > 1;

        if (!needsChange) continue;

        if (giftLines.length === 0 && desiredQuantity > 0) {
          await addGift(desiredQuantity);
        } else if (giftLines.length > 0) {
          await changeGiftLine(giftLines[0].key, desiredQuantity);
          for (var i = 1; i < giftLines.length; i += 1) {
            await changeGiftLine(giftLines[i].key, 0);
          }
        }
        refreshCartMarkup();
      } while (pending);
    }());

    return reconcilePromise.finally(function () {
      reconcilePromise = null;
      if (pending) scheduleReconcile();
    });
  }

  async function prepareCheckout() {
    if (checkoutPromise) return checkoutPromise;

    checkoutPromise = (async function () {
      var promotionActive = isPromotionActive();
      var eligibility = await Promise.all([
        promotionActive
          ? loadCollectionProductIds(CONFIG.polyCollectionHandle)
          : Promise.resolve({}),
        promotionActive
          ? loadCollectionProductIds(CONFIG.spindownCollectionHandle)
          : Promise.resolve({})
      ]);

      for (var attempt = 0; attempt < 5; attempt += 1) {
        await reconcileGift();
        var before = await getCart();
        promotionActive = isPromotionActive();
        var polyCount = promotionActive ? eligibleQuantity(before, eligibility[0]) : 0;
        var spindownCount = promotionActive ? eligibleQuantity(before, eligibility[1]) : 0;
        var expectedAttributes = {
          'Gen Con reward rule': CONFIG.rewardRule,
          'Mystery bonus dice': String(polyCount),
          'Mystery slipcases': String(Math.floor(polyCount / 3)),
          'Spindown entitlements': String(spindownCount)
        };

        if (managedGiftQuantity(before) !== spindownCount) {
          pending = true;
          continue;
        }

        await updateCartAttributes(expectedAttributes);
        var after = await getCart();
        if (cartSignature(before) === cartSignature(after)
          && managedGiftQuantity(after) === spindownCount
          && attributesMatch(after, expectedAttributes)) {
          return after;
        }
        pending = true;
      }

      throw new Error('The cart changed while rewards were being confirmed.');
    }());

    return checkoutPromise.finally(function () {
      checkoutPromise = null;
    });
  }

  function scheduleReconcile() {
    if (checkoutPreparing) {
      pending = true;
      return;
    }
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      reconcileGift().catch(function (error) {
        console.error('[Gen Con free Spindown]', error);
      });
    }, CONFIG.debounceMs);
  }

  function checkoutStatus(form) {
    return form.querySelector('[data-ib-checkout-status]');
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var submitter = event.submitter || document.activeElement;
    var isCheckout = form && form.matches('form[action*="/cart"]')
      && submitter
      && (submitter.name === 'checkout' || submitter.matches('[data-ib-checkout]'));
    if (!isCheckout) return;
    if (checkoutBypassForm === form) {
      checkoutBypassForm = null;
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    var originalLabel = submitter.textContent;
    var status = checkoutStatus(form);
    submitter.disabled = true;
    submitter.textContent = 'Confirming rewards...';
    if (status) status.textContent = 'Confirming your eligible gifts before checkout.';
    setCheckoutPreparing(true);

    prepareCheckout().then(function () {
      submitter.disabled = false;
      submitter.textContent = originalLabel;
      if (status) status.textContent = '';
      checkoutBypassForm = form;
      if (form.requestSubmit) {
        try {
          form.requestSubmit(submitter);
        } finally {
          window.setTimeout(function () {
            if (checkoutBypassForm === form) checkoutBypassForm = null;
            setCheckoutPreparing(false);
          }, 0);
        }
      } else {
        var checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = 'Checkout';
        form.appendChild(checkoutInput);
        form.submit();
      }
    }).catch(function (error) {
      console.error('[Gen Con checkout preparation]', error);
      checkoutBypassForm = null;
      setCheckoutPreparing(false);
      submitter.disabled = false;
      submitter.textContent = originalLabel;
      if (status) {
        status.textContent = 'We could not confirm your promotional gifts. Please try checkout again.';
        status.focus();
      }
    });
  }, true);

  ['click', 'input', 'change'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (!checkoutPreparing || !isCartMutationControl(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
  });

  document.addEventListener('ajaxProduct:added', scheduleReconcile);
  document.addEventListener('cart:updated', scheduleReconcile);
  document.addEventListener('page:loaded', scheduleReconcile);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleReconcile();
      schedulePromotionExpiryRefresh();
    }, { once: true });
  } else {
    scheduleReconcile();
    schedulePromotionExpiryRefresh();
  }

  window.InfiniteBlackGenConGift = {
    reconcile: reconcileGift,
    prepareCheckout: prepareCheckout,
    config: CONFIG
  };
}());

